<ng-container *ngIf="overview$ | async">
  <avn-count-card-grid [colMax]="5" [cardWidth]="100" [gap]="'10px'">
    <avn-count-card
      *ngIf="dataSource.get('videoCount')"
      [value]="dataSource.get('videoCount').value"
      [uom]="dataSource.get('videoCount').uom"
      [footerText]="dataSource.get('videoCount').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
    <avn-count-card
      *ngIf="dataSource.get('videoDiskSpace')"
      [value]="dataSource.get('videoDiskSpace').value"
      [uom]="dataSource.get('videoDiskSpace').uom"
      [footerText]="dataSource.get('videoDiskSpace').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
    <avn-count-card
      *ngIf="dataSource.get('imageCount')"
      [value]="dataSource.get('imageCount').value"
      [uom]="dataSource.get('imageCount').uom"
      [footerText]="dataSource.get('imageCount').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
    <avn-count-card
      *ngIf="dataSource.get('imageDiskSpace')"
      [value]="dataSource.get('imageDiskSpace').value"
      [uom]="dataSource.get('imageDiskSpace').uom"
      [footerText]="dataSource.get('imageDiskSpace').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
    <avn-count-card
      *ngIf="dataSource.get('htmlArchiveCount')"
      [value]="dataSource.get('htmlArchiveCount').value"
      [uom]="dataSource.get('htmlArchiveCount').uom"
      [footerText]="dataSource.get('htmlArchiveCount').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
    <avn-count-card
      *ngIf="dataSource.get('htmlArchiveDiskSpace')"
      [value]="dataSource.get('htmlArchiveDiskSpace').value"
      [uom]="dataSource.get('htmlArchiveDiskSpace').uom"
      [footerText]="dataSource.get('htmlArchiveDiskSpace').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
    <avn-count-card
      *ngIf="dataSource.get('playlistCount')"
      [value]="dataSource.get('playlistCount').value"
      [uom]="dataSource.get('playlistCount').uom"
      [footerText]="dataSource.get('playlistCount').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
    <avn-count-card
      *ngIf="dataSource.get('freeDiskSpace')"
      [value]="dataSource.get('freeDiskSpace').value"
      [uom]="dataSource.get('freeDiskSpace').uom"
      [footerText]="dataSource.get('freeDiskSpace').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
    <avn-count-card
      *ngIf="dataSource.get('usedDiskSpace')"
      [value]="dataSource.get('usedDiskSpace').value"
      [uom]="dataSource.get('usedDiskSpace').uom"
      [footerText]="dataSource.get('usedDiskSpace').footerText"
      [valueSize]="CountCardValueSize.lg"
    ></avn-count-card>
  </avn-count-card-grid>
</ng-container>
